import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getTransportSourceList(params) {
  return request({
    url: URL.mdm.basicData.transportSource,
    method: 'get',
    params
  })
}

export function saveTransportSource(data) {
  return request({
    url: URL.mdm.basicData.transportSource,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delTransportSource(uuid) {
  return request({
    url: URL.mdm.basicData.transportSource + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
